import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '../../../key-registry'
import { fromTransitOperationLogResponses } from '../models/mapper'
import { TransitOperationLog } from '../models/types'
import { fetchTransitOperationLogsV2 } from './http'

export async function fetchTransitOperationLogs(transitOperationId: number): Promise<TransitOperationLog[]> {
  const responses = await fetchTransitOperationLogsV2(transitOperationId)
  return fromTransitOperationLogResponses(responses)
}

export function transitOperationLogsQueryOptions(transitOperationId: number | null) {
  return {
    queryKey: QueryKeys.eventLog.all(transitOperationId),
    queryFn: () => fetchTransitOperationLogs(transitOperationId as number),
    staleTime: 0,
  }
}

export function useFetchTransitOperationLogs(transitOperationId: number | null) {
  return useQuery({
    ...transitOperationLogsQueryOptions(transitOperationId),
    enabled: !!transitOperationId,
  })
}
